import {FmlxToast} from 'fmlx-common-ui';
import {uniqueId} from 'lodash';

import {TOAST_TIMEOUT} from '@/constants/constant';

import {Toast} from '../../constants/actionType';

export const showToast =
  (variant, title, content, placement = FmlxToast.Placement.TOP_CENTER, timeout = TOAST_TIMEOUT) =>
  (dispatch, getState) => {
    const {toastState} = getState();
    const id = uniqueId();

    dispatch({
      type: Toast.SHOW,
      ...toastState,
      show: true,
      variant,
      title: title || '',
      content: content || '',
      timeout,
      placement,
      id,
    });
  };

export const hideToast = () => ({type: Toast.HIDE});

export function showErrorToast(title, content, placement = FmlxToast.Placement.TOP_CENTER, timeout = TOAST_TIMEOUT) {
  return (dispatch) => {
    dispatch(showToast(FmlxToast.Variant.ERROR, title, content, placement, timeout));
  };
}

export function showInfoToast(title, content, placement = FmlxToast.Placement.TOP_CENTER, timeout = TOAST_TIMEOUT) {
  return (dispatch) => {
    dispatch(showToast(FmlxToast.Variant.INFO, title, content, placement, timeout));
  };
}

export function showSuccessToast(title, content, placement = FmlxToast.Placement.TOP_CENTER, timeout = TOAST_TIMEOUT) {
  return (dispatch) => {
    dispatch(showToast(FmlxToast.Variant.SUCCESS, title, content, placement, timeout));
  };
}

export function showWarningToast(title, content, placement = FmlxToast.Placement.TOP_CENTER, timeout = TOAST_TIMEOUT) {
  return (dispatch) => {
    dispatch(showToast(FmlxToast.Variant.WARNING, title, content, placement, timeout));
  };
}
